import { render, staticRenderFns } from "./LcChopFont.vue?vue&type=template&id=62df878c&"
import script from "./LcChopFont.vue?vue&type=script&lang=js&"
export * from "./LcChopFont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports